import React from 'react';
import { connect } from 'react-redux';

import { setSupportLink } from '../../../../../../_actions/question-library.action'

const Link = ({ question, dispatch }) => {
  const supportLink = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink'
  });

  return <div className="form-group">
    <label htmlFor="question"><strong>Link</strong></label>
    <input
      onChange={(e) => { dispatch(setSupportLink(question, e.target.value)) }}
      value={supportLink ? supportLink.valueUri : ''}
      type="text"
      className="form-control"
      placeholder="http://www.axshealthapp.com"
    />
  </div>
}

export default connect()(Link)